import { useContext, useState } from "react";
import { MdAdd, MdArrowForward, MdRemove } from "react-icons/md";
import { AppContext } from "../App";
import { serviceCategories } from "./ServicesContent";

export default function HomeServicesContent() {
  const appContext = useContext(AppContext);
  const [activeSlug, setActiveSlug] = useState(serviceCategories[0].slug);

  function goToService(slug) {
    appContext.navTo({ item: "services", subItem: slug });
  }

  return (
    <section className="tgm-section tgm-home-services" data-aos="fade-up">
      <div className="container">
        <div className="tgm-home-section-top">
          <div>
            <h2>In-Demand Services</h2>
            <p>
              Construction services structured to adapt, coordinate specialist
              trades, and deliver the built environments our clients need.
            </p>
          </div>
          <button
            type="button"
            className="tgm-solid-btn"
            onClick={() => appContext.navTo({ item: "services" })}
          >
            View more
          </button>
        </div>

        <div className="tgm-service-accordion">
          {serviceCategories.map((service) => {
            const isActive = activeSlug === service.slug;

            return (
              <article
                className="tgm-service-accordion-item"
                data-active={isActive}
                key={service.slug}
              >
                <button
                  type="button"
                  className="tgm-service-accordion-trigger"
                  onClick={() => setActiveSlug(service.slug)}
                >
                  <span>{service.title}</span>
                  <span className="tgm-service-toggle" aria-hidden="true">
                    {isActive ? <MdRemove /> : <MdAdd />}
                  </span>
                </button>

                {isActive ? (
                  <div className="tgm-service-accordion-panel">
                    <div className="tgm-service-panel-copy">
                      <p>{service.summary}</p>
                      <button
                        type="button"
                        className="tgm-outline-btn"
                        onClick={() => goToService(service.slug)}
                      >
                        Explore Now <MdArrowForward />
                      </button>
                    </div>
                    <div className="tgm-service-panel-image">
                      <img src={service.heroImage} alt={service.title} />
                    </div>
                  </div>
                ) : null}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
